import * as React from 'react';
const SvgReviewAppraisalTypeLong = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 25, height: 20, fill: "none" }, props),
    React.createElement("rect", { width: 25, height: 2, fill: "#fff", rx: 1 }),
    React.createElement("rect", { width: 25, height: 2, y: 6, fill: "#fff", rx: 1 }),
    React.createElement("rect", { width: 25, height: 2, y: 12, fill: "#fff", rx: 1 }),
    React.createElement("rect", { width: 25, height: 2, y: 18, fill: "#fff", rx: 1 })));
export default SvgReviewAppraisalTypeLong;
